import React from "react";
import { createTheme } from "@mui/material/styles";
import styles from "./text.module.scss";

const ERCText = ({
  children,
  weight = "400",
  hoverColor = "#ff0000",
  size = "18px",
  color = "#252525",
  width,
  lHeight = "18px",
  onClick,
  isLink,
  textOverflow,
  underline,
  borderColor,
  align = "left",
  extrastyles,
  inline = true,
  textStroke,
  ...props
}) => {
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  });

  return (
    <div style={{ display: theme ? "hidden" : "" }}>
      <p
        className={styles.body}
        style={{
          fontFamily: "Manrope",
          fontSize: size,
          fontWeight: weight,
          color,
          // cursor: "pointer",
          textOverflow: textOverflow,
          WebkitTextStrokeColor: textStroke,
          lineHeight: lHeight,
          // letterSpacing: lSpacing,
          textAlign: align,
          textDecorationThickness: "1.5px",
          cursor: isLink ? "pointer" : "auto",
          textDecoration: underline ? "underline" : "none",
          textDecorationStyle: "solid",
          display: inline ? (width ? "block" : "inline") : "block",
          width,
          ...extrastyles,
        }}
        onClick={onClick}
        // onMouseEnter={(e) => {
        //     e.target.style.color = hoverColor; // Change text color on hover
        // }}
        // onMouseLeave={(e) => {
        //     e.target.style.color = color; // Revert to original color
        // }}
        {...props}
      >
        {children}
      </p>
    </div>
  );
};

const ERCDropdownText = ({
  children,
  weight = "400",
  size = "18px",
  color = "#00296B",
  width,
  hoverColor = "#ff0000",
  lHeight = "normal",
  onClick,
  isLink,
  textOverflow,
  underline,
  align = "left",
  extrastyles,
  inline = true,
  textStroke,
  props,
}) => {
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  });

  return (
    <div style={{ display: theme ? "hidden" : "" }}>
      <p
        className={styles.body}
        style={{
          fontFamily: "Manrope",
          fontSize: size,
          fontWeight: weight,
          color,
          textOverflow: textOverflow,
          WebkitTextStrokeColor: textStroke,
          lineHeight: lHeight,
          textAlign: align,
          textDecorationThickness: "1.5px",
          cursor: isLink ? "pointer" : "auto",
          textDecoration: underline ? "underline" : "none",
          textDecorationStyle: "solid",
          display: inline ? (width ? "block" : "inline") : "block",
          width,
          // transition: 'color 0.3s ease',
          ...extrastyles,
        }}
        onClick={onClick}
        onMouseEnter={(e) => {
          e.target.style.color = hoverColor; // Change text color on hover
        }}
        onMouseLeave={(e) => {
          e.target.style.color = color; // Revert to original color
        }}
        {...props}
      >
        <div
          style={{
            display: "flex",
            gap: "8px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {children}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="21"
            viewBox="0 0 18 21"
            fill="none"
          >
            <g filter="url(#filter0_d_4132_11544)">
              <path
                d="M9.77771 12.0378C9.37747 12.533 8.62253 12.533 8.22229 12.0378L4.25422 7.12862C3.72565 6.47468 4.19108 5.5 5.03193 5.5L12.9681 5.5C13.8089 5.5 14.2744 6.47468 13.7458 7.12862L9.77771 12.0378Z"
                fill="#00296B"
              />
              <path
                d="M8.61114 11.7235L4.64308 6.81431C4.37879 6.48734 4.61151 6 5.03193 6L12.9681 6C13.3885 6 13.6212 6.48734 13.3569 6.81431L9.38886 11.7235C9.18873 11.9711 8.81127 11.9711 8.61114 11.7235Z"
                stroke="black"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_4132_11544"
                x="0.0292969"
                y="5.5"
                width="17.9414"
                height="14.9092"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_4132_11544"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_4132_11544"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
      </p>
    </div>
  );
};

export { ERCText, ERCDropdownText };
